export default __webpack_public_path__ + "static/media/Indicator.6f4fafe0.svg";